export default __webpack_public_path__ + "static/media/Half-Round-Pipe-Insulation.dd2ac277.jpg";